import React, {
    useContext, useMemo
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter
} from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { SgWebchatUtil } from 'saga-modules';
import htmlParser from 'html-react-parser';
import messages from './SgSptPhoneModal.messages';

function SgSptPhoneModal(props) {
    const {
        isOpen,
        onResolve,
        className,
        phoneNumber
    } = props;

    const breakpoint = useContext(BreakpointTrackerContext);
    const isMobile = breakpoint === 'phone';
    const translator = useContext(TranslatorContext);
    const openHours = SgWebchatUtil.openHours();

    const needHelpSection = useMemo(() => {
        return (
            <>
                <div className="sgNeedHelpModalContent">
                    <div className="sgSptPhoneModalContentSection">
                        <i className="mi mi-chat-bubble" />
                        <div className="sgSptPhoneModalContentText">
                            <p>{htmlParser(translator(messages.ChatOnlineMsgOne))}</p>
                            <p>{translator(messages.ChatOnlineMsgTwo)}</p>
                        </div>
                        <button
                            type="button"
                            className="saga-intercom sgButton sgTransactionButton"
                            onClick={() => { SgWebchatUtil.trackChat(); }}
                        >
                            {openHours ? translator(messages.ChatOnlineButton) : translator(messages.LeaveMessage)}
                        </button>
                    </div>
                    <div className="sgSptPhoneModalContentDivider">
                        <hr className="sgSptPhoneModalContentDividerLine" />
                        <div className="sgSptPhoneModalContentDividerMessage">{translator(messages.Or)}</div>
                    </div>
                    <div className="sgSptPhoneModalContentSection">
                        <i className="mi mi-call" />
                        <div className="sgSptPhoneModalContentText">
                            <p>{htmlParser(translator(messages.CallUsMsgOne))}</p>
                            <p>{translator(messages.CallUsMsgTwo)}</p>
                        </div>
                        <div className="sgSptPhoneModalContentPhoneLines">
                            <p>{translator(messages.LinesAreCurrently)}</p>
                            {openHours && (
                                <>
                                    <p className="sgModalPhoneLinesOpen">{translator(messages.Open)}</p>
                                    <p>{translator(messages.PleaseCall)}</p>
                                    <p className="sgPhoneNumber">{phoneNumber}</p>
                                </>
                            )}
                            {!openHours && (
                                <>
                                    <p className="sgModalPhoneLinesClosed">{translator(messages.Closed)}</p>
                                    <ul className="sgPhoneLineOpeningTimes">
                                        <li>{translator(messages.TimeWeekDays)}</li>
                                        <li>{translator(messages.TimeSaturday)}</li>
                                        <li>
                                            {translator(messages.TimeSunday)}
                                            <span className="sgModalPhoneLinesClosed">{translator(messages.Closed)}</span>
                                        </li>
                                    </ul>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    }, [openHours, phoneNumber, translator]);

    const needHelpSectionMobile = useMemo(() => {
        return (
            <>
                <div className="sgNeedHelpModalContent">
                    <div className="sgSptPhoneModalContentSection">
                        { openHours && (
                            <div className="sgSptPhoneModalContentText">
                                <p>{htmlParser(translator(messages.ChatOnlineMsgOne))}</p>
                                <p>{translator(messages.ChatOnlineMsgTwo)}</p>
                            </div>
                        )}
                        <button
                            type="button"
                            className="saga-intercom sgButton sgTransactionButton"
                            onClick={() => { SgWebchatUtil.trackChat(); onResolve(); }}
                        >
                            {openHours ? translator(messages.ChatOnlineButton) : translator(messages.LeaveMessage)}
                        </button>
                        <div className="sgSptPhoneModalContentText">
                            <p>{htmlParser(translator(messages.CallUsMsgOne))}</p>
                            <p>{translator(messages.CallUsMsgTwo)}</p>
                        </div>
                        <div className="sgSptPhoneModalContentPhoneLines">
                            <p>{translator(messages.LinesAreCurrently)}</p>
                            {openHours && (
                                <>
                                    <p className="sgModalPhoneLinesOpen">{translator(messages.Open)}</p>
                                    <p>{translator(messages.PleaseCall)}</p>
                                    <p className="sgPhoneNumber"><a href={`tel:${phoneNumber}`}>{phoneNumber}</a></p>
                                </>
                            )}
                            {!openHours && (
                                <>
                                    <p className="sgModalPhoneLinesClosed">{translator(messages.Closed)}</p>
                                    <ul className="sgPhoneLineOpeningTimes">
                                        <li>{translator(messages.TimeWeekDays)}</li>
                                        <li>{translator(messages.TimeSaturday)}</li>
                                        <li>
                                            {translator(messages.TimeSunday)}
                                            <span className="sgModalPhoneLinesClosed">{translator(messages.Closed)}</span>
                                        </li>
                                    </ul>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    }, [onResolve, openHours, phoneNumber, translator]);

    return (
        <ModalNext isOpen={isOpen}>
            <div className={`${className} sgLargeModal sgSptPhoneModal`}>
                <ModalHeader
                    title={translator(messages.NeedHelp)}
                    onClose={onResolve}
                />
                <ModalBody>
                    <div>{isMobile ? needHelpSectionMobile : needHelpSection}</div>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onResolve} className="sgButton sgSecondaryButton">
                        {translator(messages.CloseButton)}
                    </Button>
                </ModalFooter>
            </div>
        </ModalNext>

    );
}

export default SgSptPhoneModal;
